import toastr from 'react-hot-toast'
import { useQuery } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import type { SasTokenResponse } from 'types/SasToken'

export function useGetBlobSasToken(containerName: string) {
  const getSasToken = async () => {
    if (!containerName) {
      Promise.reject('Container Name can not be null')
    }

    const body = {
      data: {
        type: 'sasTokens',
        attributes: {
          containerName,
        },
      },
    }

    return fetchWrapper<SasTokenResponse>({
      url: `sasTokens`,
      method: 'POST',
      body: body,
    })
  }

  return useQuery('getSasToken', getSasToken, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Get Sas Token: ${error.message}`)
      }
    },
    staleTime: 1000,
    cacheTime: 0,
    enabled: false,
  })
}
